import { Injectable } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { CharacteristicObject } from 'src/app/models/characteristics/characteristic/characteristic-object.model';
import { CharacteristicsObject } from 'src/app/models/characteristics/characteristics.model';
import { Converter } from '../converter.interface';
import { CharacteristicConverter } from './characteristic.converter';

@Injectable({
    providedIn: 'root'
})
export class CharacteristicsConverter implements Converter<CharacteristicsObject> {

    constructor(private characteristicConverter: CharacteristicConverter) { }

    convert(characteristics: any): CharacteristicsObject {
        if (!characteristics) {
            return CharacteristicsObject.create();
        }
        if (isNullOrUndefined(characteristics.in) || isNullOrUndefined(characteristics.out)) {
            this.throwError();
        } else {
            const inputCharacteristics = new Array<CharacteristicObject>();
            const outputCharacteristics = new Array<CharacteristicObject>();
            for (const inputChar of characteristics.in) {
                inputCharacteristics.push(this.characteristicConverter.convert(inputChar));
            }
            for (const outputChar of characteristics.out) {
                outputCharacteristics.push(this.characteristicConverter.convert(outputChar));
            }
            return new CharacteristicsObject(inputCharacteristics, outputCharacteristics);
        }
    }


    throwError(): CharacteristicsObject {
        throw new Error("There is not an characteristic/output characteristics structure in the response");
    }
}
